import React, { forwardRef, Key, PropsWithChildren, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import styles from './Fader.module.css';

interface FaderProps {
    contentKey: Key;
    className?: string;
}

export const Fader = forwardRef<HTMLDivElement, PropsWithChildren<FaderProps>>(
    ({ contentKey, className, children }, ref) => {
        const [currentChildren, setCurrentChildren] = useState(children);
        const [fading, setFading] = useState(false);
        const prevKey = useRef(contentKey);

        useEffect(() => {
            if (prevKey.current === contentKey) {
                return;
            }
            prevKey.current = contentKey;
            setFading(true);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [contentKey]);

        const handleTransitionEnd = () => {
            if (fading) {
                setCurrentChildren(children);
                setFading(false);
            }
        };

        return (
            <div
                ref={ref}
                className={classnames(styles.root, className, {
                    [styles.fadeOut]: fading,
                })}
                onTransitionEnd={handleTransitionEnd}
            >
                {currentChildren}
            </div>
        );
    }
);
